import { Button, Card, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import EventEmitter from '../../utils/eventEmitter';
import { useNavigate } from 'react-router-dom';
import { LiaBackspaceSolid } from "react-icons/lia";
import { errorModal, successModal } from './ModalMessages';

// import Axios from '../utils/axios';
const gridStyle = {
  width: '33.3%',
  height: '70px',
  padding: '0px',
  
};

let pass = '';
const PinModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [cashier, setCashier] = useState({});
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  

  const handleOk = async () => {
    try {
      let data = {...cashier};
      if (data.pin === password) {
        EventEmitter.dispatch('cashier_choosen', data);
        localStorage.setItem(`caspian_pos_cashier`, JSON.stringify(data));
        successModal(
          <h4 style={{textTransform: 'uppercase'}}>WELCOME BACK, {cashier.name}!</h4>,
          <>
            <p className='mb-4'>
              Let’s provide an excellent experience for every customer! 💪 
            </p>
            <p>Good Luck</p>
          </>
          )
        navigate('/pos/session/sells');
        setIsModalOpen(false);
        
      }else {
        errorModal(
          'INCORRECT PASSWORD!',
          <div>
            <p>The password you entered is incorrect.</p>
            <p>Please check, and try again.</p>
          </div>
        );
      }
    }catch (err) {
      console.log(err);
    }
  }

  

  useEffect(() => {
    EventEmitter.subscribe('openpinmodal', info => {
      setIsModalOpen(true);
      setCashier(info);
    });
    
    return () => EventEmitter.unsubscribe('openpinmodal');
  },[])


  const addPasscode = (number) => {
    // let passcode = password;
    // passcode += String(number);
    
    setPassword((passcode) => passcode + String(number));
  }

  const removePasscode = () => {
    if (password !== '') {
      let passcode = password;
      // console.log(passcode);
      let passcode_ = password.split('');
      
      passcode_.pop();
      passcode = passcode_.join('');
      
      setPassword(passcode);
    }
  };

  const resetPasscode = () => setPassword('');

  const handleKeyboardInput = (event) => {
    const key = event.key;

    // Check if the key is a number (0-9) or decimal point (.)
    if (/[0-9]/.test(key)) {
      addPasscode(key);
    }

    // Check for Enter key to trigger calculation
    else if (key === "Enter") {
      handleOk();
    }
    // Check for backspace key to clear the last character (delete)
    else if (key === "Backspace") {
      removePasscode();
    }
    // Check for Escape key to clear the display
    else if (key === "Escape") {
      resetPasscode();
    }
  };

  
  return (
    <div onKeyDown={handleKeyboardInput}>
      <Modal centered width={'300px'} keyboard={false} closable={false} open={isModalOpen} onCancel={handleCancel} footer={<></>}>
        <div id='passcode-container'>
          <div style={{height: '50px'}}>
            <h2 className='text-center text-2xl font-semibold'>Password?</h2>
          </div>
          <div className='passcode-body '>
            <div className='passcode-display-container'>
              <input readOnly type='password' value={password}/>
            </div>
            <div>
              <Card className=''>
                {Array.from({ length: 9 }, (v, i) => i + 1).map(item => 
                  <Card.Grid key={item} style={gridStyle}>
                    <Button type='text' onClick={()=> addPasscode(item)} className='w-full h-full font-semibold'>{item}</Button>
                  </Card.Grid>
                )}
                <Card.Grid style={gridStyle}>
                  <Button type='text' onClick={resetPasscode} className='w-full h-full font-semibold'>C</Button>
                </Card.Grid>
                <Card.Grid style={gridStyle}>
                  <Button type='text' onClick={() => addPasscode(0)} className='w-full h-full font-semibold'>0</Button>
                </Card.Grid>
                <Card.Grid style={gridStyle} >
                  <Button type='text' onClick={removePasscode} className='w-full h-full font-semibold flex justify-center items-center'><LiaBackspaceSolid size={'1.7rem'} width={'100%'}/></Button>
                </Card.Grid>
              </Card>
            </div>
          </div>
          <div className='flex justify-between pt-2 '>
            <Button className='font-semibold text-gray-700' style={{width: '47%', height: '40px'}} onClick={handleCancel} type='default'>Cancel</Button>
            <Button className='font-semibold text-gray-700' onClick={handleOk} style={{width: '47%', height: '40px'}} >Ok</Button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default PinModal;